/**
 * ¿La app se está abriendo en la vuelta de la pasarela (Mercado Pago o
 * WeTravel, CAT-4903) con el pago aprobado?
 *
 * Es el único caso donde la pantalla destino trae su PROPIO loader con
 * mensajes de progreso (`EmissionProgressComponent`): el splash genérico del
 * layout taparía ese feedback y, peor, retrasa el arranque del retrieve —que
 * ya espera a que el back termine de emitir— con una espera vacía.
 *
 * La detección es por path/query, agnóstica de la pasarela: WeTravel
 * comparte el mismo back_url `/confirmation/success` que Mercado Pago (la
 * vuelta ocurre en la misma pestaña, dentro del iframe), así que no hace
 * falta lógica nueva para que también aplique a WeTravel.
 *
 * Se compara con `endsWith` para que siga funcionando si la app se sirve bajo
 * un subpath.
 */
export function isApprovedGatewayReturn(url: string): boolean {
  const [rawPath = '', query = ''] = url.split('?');
  const path = rawPath.replace(/\/+$/, '');

  // back_url de la pasarela: redirige por path, no por query param.
  if (path.endsWith('/confirmation/success')) {
    return true;
  }

  return (
    path.endsWith('/confirmation') &&
    new URLSearchParams(query).get('status') === 'approved'
  );
}

/**
 * Alias de compatibilidad (pre-CAT-4903): mismo nombre que usan los callers
 * existentes (`layout.component.ts`, specs). No duplica lógica.
 */
export const isApprovedMercadoPagoReturn = isApprovedGatewayReturn;
